export const hasInvalidPasswordCharacter = (password: string): boolean => {
  return /[^A-Za-z\d~@\-_#$%^&*+=`|{}:;!.?"()[\]\\]/.test(password);
};
